import { AccountsService } from "../../../services";
import { resolve } from 'path';

interface IResolve {
    reminderIntervals: any;
}

class ReminderIntervalController {
    private resolve: IResolve;
    private onUpdate: any;
    private onDelete: any;
    private reminderInterval: any;
    private reminderIntervals: any[];

    constructor(private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private AccountsService: AccountsService) {
        'ngInject';
        // console.log('ReminderIntervalController');
    }

    public $onInit = () => {
        this.reminderIntervals = this.resolve.reminderIntervals.reminderIntervals;
        
        if (this.$stateParams['index']) {
            this.reminderInterval = this.reminderIntervals.find(s => s.index == this.$stateParams['index']);
        } else {
            this.reminderInterval = {};
        }
    }

    submit() {
        if (!this.reminderInterval.index) {
            this.reminderInterval.index = this.reminderIntervals.length;
            this.reminderIntervals.push(this.reminderInterval);
        }

        this.AccountsService.customPut(this.$stateParams['id'] + '/nomatchfoundemailsettings', { reminderIntervals: this.reminderIntervals }).then(result => {
            this.closeModal();
        });
    }

    delete() {
        this.reminderIntervals = this.reminderIntervals.filter(i => i.index !== this.reminderInterval.index);
        this.AccountsService.customPut(this.$stateParams['id'] + '/nomatchfoundemailsettings', { reminderIntervals: this.reminderIntervals }).then(result => {
            this.closeModal();
        })
    }

    private closeModal() {
        this.$state.go('^', {tab: 6}, {reload: true});
    }
}

export const reminderIntervalComponent = {
    bindings: {
        resolve: '<'
    },
    controller: ReminderIntervalController,
    template: require('./reminderIntervalModal.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/accounts/reminderIntervalModal.component.ts